<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <base-notice-item
    data-test="global-contract-type-company-alert"
    :button-text="buttonText"
    :button-url="buttonUrl"
    :completed="completed"
  >
    <template #head>
      <strong>Contract type setup</strong>
    </template>
    <template #icon>
      <img src="/gfx/worker-classification-logo-indigo.svg" />
    </template>
    <template #body>
      All contracts require you to specify the contractor’s worker status. This is the first step to
      find out if you want to hire as an Contractor, Employee worker on a payroll contract or if you want
      to use the Worker Classification questionnaire to determine the employment status.
    </template>
    <template #status>
      <div class="f-500">
        Status:
        <template v-if="completed">
          {{ $t('Completed') }}
          <span class="c-black">Contract type is {{ contractTypeLabel }}</span>
        </template>
        <template v-else>{{ $t('Pending') }}</template>
      </div>
    </template>
  </base-notice-item>
</template>

<script>
import { computed } from 'vue'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

export default {
  name: 'GlobalContractTypeCompanyAlert',
  props: {
    hireId: {
      type: [Number, String],
      required: true,
    },
    contractTypeLabel: {
      type: String,
      required: true,
    },
    completed: {
      type: Boolean,
      required: true,
    },
    hasBills: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const buttonUrl = computed(() => {
      if (props.hasBills) return undefined

      return laravelNamedRoute(
        namedRoutes.hires.show['contracts-type'],
        {
          hire: props.hireId,
          id: props.hireId,
          redirect_uri: window.location.pathname + window.location.search,
        },
        false,
      )
    })

    const buttonText = computed(() => {
      if (props.hasBills) return undefined

      return props.completed ? 'Change contract type' : 'Start'
    })

    return {
      buttonUrl,
      buttonText,
    }
  },
}
</script>
